import React, { useState } from 'react'
import styled from 'styled-components'
import { t } from '@/i18n'
import { useTemplateData } from '../../hooks/useTemplateData'
import TemplateTable from './TemplateTable'
import { Checkbox, Input } from 'antd'
import { IconFont } from '@/components'

interface TemplateSelectorProps {
  taskParams?: any
  onTemplateSelectionChange?: (
    selectedTemplates: string[],
    executeUpdateTemplates: string[],
  ) => void
}

const TemplateSelector: React.FC<TemplateSelectorProps> = ({
  taskParams = {},
  onTemplateSelectionChange,
}) => {
  // 本地搜索输入状态
  const [searchValue, setSearchValue] = useState('')

  const {
    templates,
    templateIds,
    loading,
    pagination,
    selectedTemplates,
    executeUpdateTemplates,
    searchTemplates,
    selectTemplate,
    selectAllTemplates,
    setExecuteUpdate,
    handleTableChange,
    handleTableSelectChange,
  } = useTemplateData(taskParams, onTemplateSelectionChange)

  return (
    <Container>
      <Header>
        <div className="title">{t('模板选择')}</div>
        <Input
          style={{ width: 260 }}
          prefix={<IconFont type="icon-sousuo2" style={{ color: '#666', fontSize: '16px' }} />}
          placeholder={t('模板名称')}
          value={searchValue}
          onChange={e => {
            const value = e.target.value
            setSearchValue(value)
            searchTemplates(value)
          }}
        />
      </Header>
      <Checkbox
        style={{ marginLeft: 6 }}
        disabled={templateIds?.length === 0}
        checked={selectedTemplates?.length > 0 && selectedTemplates?.length === templateIds?.length}
        onChange={e => selectAllTemplates(e.target.checked)}
      >
        {t('全选所有')}
      </Checkbox>

      <TemplateTable
        data={templates}
        loading={loading}
        pagination={pagination}
        selectedKeys={selectedTemplates}
        executeUpdateKeys={executeUpdateTemplates}
        isLatest={taskParams.isLatest}
        templateUseCaseCount={taskParams.templateUseCaseCount || {}}
        onSelectionChange={selectTemplate}
        onExecuteUpdateChange={setExecuteUpdate}
        onTableChange={handleTableChange}
        onTableSelectChange={handleTableSelectChange}
      />
    </Container>
  )
}

export default TemplateSelector

const Container = styled.div`
  width: 45.5%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 14px 16px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  .title {
    font-weight: 500;
  }
`
